import jsPDFPendingOrdersTemplate, { OutputType } from "./PendingOrdersTemplate";
import currency from 'currency.js'

// Date Fns is used to format the dates we receive
// from our API call
import { parseISO, format } from 'date-fns';
import logo from '../../../assets/img/logo.jpg'; // Tell webpack this JS file uses this image


// define a generatePDF function that accepts a mainDatas argument
const generatePendingOrdersPrintPDF = (mainData, configData, parameters) => {
    
    // console.log("data:",mainData)
    const myDate = format(new Date(), 'dd/MM/yyyy')
    const dateFrom = format(new Date(parameters.date_from), 'dd/MM/yyyy')
    const dateTo = format(new Date(parameters.date_to), 'dd/MM/yyyy')
    const dataFrom = parameters.data_from === "" ? "0" : parameters.data_from
    const dataTo = parameters.data_to === "" ? "999999999" : parameters.data_to
    const currFormat = { decimal: ',', symbol: '', separator: '.' }

    var totalOrders = 0;
    if (mainData.length > 0){
        mainData.forEach(function (record) {
            totalOrders += record.total;        
        });    
        
        totalOrders = currency(totalOrders, currFormat).format()
    
        var arrLines = Array.from(mainData, (item, index) => ([
            index + 1,
            format(new Date(item.date+ 'T23:59:59.999Z'), 'dd/MM/yyyy'),
            item.document_type.code,      
            item.document,
            item.client.name,
            currency(item.subtotal, currFormat).format(),
            currency(item.dct, currFormat).format(),
            currency(item.tax, currFormat).format(),
            currency(item.total, currFormat).format(),
    
        ]))

        arrLines = [...arrLines,
            [{content:"", colSpan: 5, styles: { fillColor: [220,220,220], textColor: [0,0,0]}},
            {
                content: `Total por facturar:`, colSpan: 3, styles: { fillColor: [220,220,220], textColor: [0,0,0]}
            },        
            {
                content: totalOrders, styles: { fillColor: [220,220,220], textColor: [0,0,0]}
            },
            ]]

    }
    

    var props = {
        outputType: 'blob',
        returnJsPDFDocObject: true,
        fileName: `pending-orders-report-${new Date()}`,
        orientationLandscape: false,
        logo: {
            src: logo,
            width: 30.33, //aspect ratio = width/height
            height: 26.66,
            margin: {
                top: 0, //negative or positive num, from the current position
                left: 0 //negative or positive num, from the current position
            }
        },        
        business: {
            name: configData.company_name,
            address: `${configData.company_address1} - ${configData.company_address2}`,
            phone: configData.company_phone,
            email: configData.company_email,
            email_1: configData.company_email1,
            website: configData.company_web_url,
            date: myDate
        },
        invoice: {
            label: `Ordenes pendiente de facturar`,    
            label2: `Desde: ${dateFrom} - Hasta: ${dateTo}`,                          
            label3: `Orden Desde: ${dataFrom} - Orden Hasta: ${dataTo}`,      
            headerBorder: true,
            tableBodyBorder: true,
            header: ["#", "Fecha", "Tipo Doc", "Numero", "Cliente", "S.Total", "DCTO.", "IVA", "Total"],
            table: arrLines,
            invTotalLabel: "",
            invTotal: 0,
            InvTotalCost: 0,
            InvTotalPrice: 0,
            invCurrency: "",
            row1: {
                
            },
            row2: {
                
            },
            row3: {
                
            },
            invDescLabel: "",
            invDesc: "",
        },
        footer: {
            text: "",
        },
        pageEnable: true,
        pageLabel: "Page ",
    };
    const pdfCreated = jsPDFPendingOrdersTemplate(props); //returns number of pages created
    var blob = pdfCreated.blob;

    var pdfObject = pdfCreated.jsPDFDocObject;


    window.open(URL.createObjectURL(pdfObject.output("blob")))

    // pdfCreated.jsPDFDocObject.output("blob"); //or .output('<outputTypeHere>');

};

export default generatePendingOrdersPrintPDF;